






























































import { Component, Vue } from 'vue-property-decorator';
import MyTasksCard from '@/modules/shared/tasks/components/MyTasksCard.vue';
import MeasurementsStats from '@/components/statistics/MeasurementsStats.vue';
import ProjectsStats from '@/components/projects/ProjectsStats.vue';
import QuotationsStats from '@/components/sales/QuotationsStats.vue';
import InvoicesStats from '@/modules/invoicing/components/InvoicesStats.vue';
import UserSettingDialog from '@/components/defaultPopups/defaultUserSettingsDialog.vue';

import axios from 'axios';

@Component({
  components: {
    MyTasksCard,
    MeasurementsStats,
    ProjectsStats,
    QuotationsStats,
    InvoicesStats,
    UserSettingDialog,
  },
})
export default class Home extends Vue {
  public show: boolean = false;
  public popupStatus: boolean = true;

  public mesurementStatsStyle: any = 'display:none';
  public projectStatsStyle: any = 'display:none';
  public quotationStatsStyle: any = 'display:none';
  public invoiceStatsStyle: any = 'display:none';

  public handleLoginEvent(data: any) {
    this.$router.push(data.state.target || '/');
  }

  public mounted() {
    const lang = localStorage.getItem('lang');
    if (lang) {
      this.setLang(lang);
    } else {
      this.setLang('nl');
    }

    if (localStorage.hasOwnProperty('mesurementStatsStyle')) {
      this.popupStatus = false;
      this.mesurementStatsStyle = localStorage.getItem('mesurementStatsStyle');
    }
    if (localStorage.hasOwnProperty('projectStatsStyle')) {
      this.popupStatus = false;
      this.projectStatsStyle = localStorage.getItem('projectStatsStyle');
    }
    if (localStorage.hasOwnProperty('quotationStatsStyle')) {
      this.popupStatus = false;
      this.quotationStatsStyle = localStorage.getItem('quotationStatsStyle');
    }
    if (localStorage.hasOwnProperty('invoiceStatsStyle')) {
      this.popupStatus = false;
      this.invoiceStatsStyle = localStorage.getItem('invoiceStatsStyle');
    }

    //const settingsDialog = this.$refs.usersettingsdialog as UserSettingDialog;
    //settingsDialog.show = this.popupStatus;

  }

  private setLang(val: string) {
    this.$i18n.locale = val;
    localStorage.setItem('lang', val);
  }
}
